export default __webpack_public_path__ + "static/media/logo_user.10691648.png";